import axios from 'axios';
import { getStoredWorkspaceId } from './context/workspaceStorage';

/**
 * Attach workspace id to all API requests (saved calculations scope).
 */
axios.interceptors.request.use((config) => {
  const workspaceId = getStoredWorkspaceId();
  if (workspaceId) {
    config.headers = config.headers ?? {};
    config.headers['X-Workspace-Id'] = workspaceId;
  }
  return config;
});
